import styled from "styled-components";

export const Styles = styled.div`
  margin-bottom: 3rem;
  width: 100%;
  table {
    table-layout: fixed;
    border-spacing: 0;
    border: 1px solid #e9e9e9;
    &.react-table-submitted,
    &.react-table-historical {
      td,
      th {
        &:last-child,
        &:first-child {
          width: 2%;
        },
      }
    }
    &.react-table-initiated {
      td,
      th {
        &:first-child {
          width: 2%;
        },
      }
    }
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th {
      background-color: #f7f7f7;
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid #e9e9e9;
      border-right: 1px solid #e9e9e9;
    }
  }
`;

export const TH = styled.th`
  padding: 0 !important;
  width: 16%;
`;

export const TH_Container = styled.div`
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;
  ${(props) => props.isSorted && `background-color: #efefef`}
`;

export const TD = styled.td`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100px;

  width: 16%;

  ${(props) =>
    props.loader &&
    `
    background-color: #f7f7f7;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #e9e9e9;
  `}
`;
export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  ${(props) => props.left && `justify-content: start;`}

  .input-page {
    margin: 0 2rem;
  }

  select {
    margin-left: 1rem;
  }
`;

export const PageNavButton = styled.button`
  background-color: #f7fafd;
  border: 1px solid white;
  border-radius: 5px;
  color: #7fa1c8;
  height: 34px;
  width: 34px;
  padding: 0;
  &:hover {
    cursor: pointer;
    color: #7fa1c8;
    background-color: #e4f0fb;
  }

  &:disabled {
    background-color: #f7f7f7;
    cursor: not-allowed;
    color: lightgray;
  }
  svg {
    margin-top: 7px;
  }
`;

export const PageInput = styled.input`
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
  padding: 5px 7px;
  font-size: inherit;
  border-radius: 3px;
  font-weight: normal;
  outline: none;
  width: 60px;
  text-align: center;
`;
